(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[18445],{

/***/ 560327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ getBanners; },
/* harmony export */   "Q": function() { return /* binding */ BannerInlinePlaceholder; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _constants_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(346115);
/* harmony import */ var cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(167520);
/* harmony import */ var _types_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(901550);
/* harmony import */ var _handlers_api_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(603651);






const filterHeightInlineInRootNode = (banners, isMobile) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m;
  let sizePopups = [];
  for (let obj of banners) {
    let content = obj.content;
    for (let key in content) {
      if (content.hasOwnProperty(key)) {
        if (content[key].parentId === "ROOT" && content[key].tag === "inlinebanner" && ((_c = (_b = (_a = content[key]) == null ? void 0 : _a.customAttributes) == null ? void 0 : _b.inlinebanner) == null ? void 0 : _c.relativePosition) === _types_es_js__WEBPACK_IMPORTED_MODULE_2__/* .ERelativePosition.IN */ .zH.IN) {
          const isPopUpShowInDesktop = !((_g = (_f = (_e = (_d = content[key]) == null ? void 0 : _d.customAttributes) == null ? void 0 : _e.inlinebanner) == null ? void 0 : _f.responsive) == null ? void 0 : _g.hiddenMd);
          const isPopUpShowInMobile = !((_k = (_j = (_i = (_h = content[key]) == null ? void 0 : _h.customAttributes) == null ? void 0 : _i.inlinebanner) == null ? void 0 : _j.responsive) == null ? void 0 : _k.hiddenXs);
          if (isMobile && isPopUpShowInMobile || !isMobile && isPopUpShowInDesktop) {
            sizePopups.push({
              className: content[key].customAttributes.inlinebanner.cssSelector,
              height: (_l = content[key].style.height) != null ? _l : 0,
              width: (_m = content[key].style.width) != null ? _m : 0
            });
          }
        }
      }
    }
  }
  return sizePopups;
};
const getBanners = async ({
  cookies,
  configs,
  env,
  flagsup
}) => {
  const { appId, iamId, trackingAppId, url, isMobile } = configs;
  const parsedCookies = cookie__WEBPACK_IMPORTED_MODULE_1__/* .parse */ .Q(cookies);
  const isNewVisitor = parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TEMPI_VP */ .CP] !== _constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .UNIDENTIFIED */ .eF || parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TEMPI_VS */ .U6] === _constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .NEW_USER */ .MB;
  const trackingId = parsedCookies[_constants_es_js__WEBPACK_IMPORTED_MODULE_3__/* .TRACKING_ID */ .tz];
  const isMa79Enabled = flagsup.epic_ma_79;
  const handleSubscribe = async () => {
    if (!appId)
      return;
    try {
      const discoveryService = new _handlers_api_es_js__WEBPACK_IMPORTED_MODULE_4__/* .OnSiteDiscoveryService */ .T(env);
      const body = {
        appId,
        iamId,
        trackingAppId,
        onlyNewVisitor: isNewVisitor,
        url,
        trackingId: isMa79Enabled ? trackingId : void 0
      };
      const banners2 = await discoveryService.subscribeSmartPopup(body);
      return filterHeightInlineInRootNode(banners2, isMobile);
    } catch (e) {
      console.error(e);
    }
  };
  const banners = await handleSubscribe() || [];
  return banners;
};
const BannerInlinePlaceholder = ({
  banners = [],
  className
}) => {
  const matchBanners = banners == null ? void 0 : banners.filter(
    (banner) => banner.className === `.${className}`
  );
  const totalBannerHeight = matchBanners == null ? void 0 : matchBanners.reduce(
    (total, banner) => total + banner.height,
    0
  );
  const maxBannerWidth = matchBanners == null ? void 0 : matchBanners.reduce(
    (max, banner) => Math.max(max, banner.width),
    0
  );
  return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
    children: matchBanners ? /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className,
      style: {
        minHeight: `${totalBannerHeight}px`,
        width: `${maxBannerWidth}px`
      }
    }) : /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
      className
    })
  });
};




/***/ }),

/***/ 346115:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CP": function() { return /* binding */ TEMPI_VP; },
/* harmony export */   "GN": function() { return /* binding */ DEFAULT_LIMIT_TIME; },
/* harmony export */   "Hi": function() { return /* binding */ RETURNING; },
/* harmony export */   "J2": function() { return /* binding */ SMART_POPUP_CONFIG; },
/* harmony export */   "MB": function() { return /* binding */ NEW_USER; },
/* harmony export */   "SI": function() { return /* binding */ EXPIRE_MINUTE; },
/* harmony export */   "U6": function() { return /* binding */ TEMPI_VS; },
/* harmony export */   "eF": function() { return /* binding */ UNIDENTIFIED; },
/* harmony export */   "hR": function() { return /* binding */ DEFAULT_DISPLAY_VALUE; },
/* harmony export */   "to": function() { return /* binding */ VIEW_INTERVAL_DURATION; },
/* harmony export */   "tz": function() { return /* binding */ TRACKING_ID; }
/* harmony export */ });
const EXPIRE_MINUTE = 20;
const TEMPI_VP = "_tempi_vp";
const TEMPI_VS = "_tempi_vs";
const SMART_POPUP_CONFIG = "_smart_banner_config";
const NEW_USER = "NEW";
const RETURNING = "RETURNING";
const UNIDENTIFIED = "unidentified";
const VIEW_INTERVAL_DURATION = 100;
const DEFAULT_DISPLAY_VALUE = 1;
const DEFAULT_LIMIT_TIME = 1;
const TRACKING_ID = "_track__track";




/***/ }),

/***/ 603651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ OnSiteDiscoveryService; }
/* harmony export */ });
/* harmony import */ var _tempi_core_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(988966);


const onSiteDiscoveryUrl = {
  dev: "https://smart-activation-discovery.dev.tekoapis.net/api",
  stag: "https://smart-activation-discovery.stag.tekoapis.net/api",
  production: "https://smart-activation-discovery.tempi.vn/api"
};
class OnSiteDiscoveryService {
  constructor(env) {
    this.client = new _tempi_core_renderer__WEBPACK_IMPORTED_MODULE_0__/* .Api */ .V(onSiteDiscoveryUrl[env]);
  }
  async subscribeSmartPopup(params) {
    var _a;
    const { data } = await this.client.post(
      "/v1/smart-activation/subscribe",
      params
    );
    return ((_a = data == null ? void 0 : data.data) == null ? void 0 : _a.popups) || [];
  }
}




/***/ }),

/***/ 901550:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RW": function() { return /* binding */ ETimeUnit; },
/* harmony export */   "Wv": function() { return /* binding */ EBannerEvent; },
/* harmony export */   "zH": function() { return /* binding */ ERelativePosition; }
/* harmony export */ });
var EBannerEvent = /* @__PURE__ */ ((EBannerEvent2) => {
  EBannerEvent2[EBannerEvent2["DISPLAY"] = 0] = "DISPLAY";
  EBannerEvent2[EBannerEvent2["CLICK"] = 1] = "CLICK";
  EBannerEvent2[EBannerEvent2["CLOSE"] = 2] = "CLOSE";
  return EBannerEvent2;
})(EBannerEvent || {});
var ETimeUnit = /* @__PURE__ */ ((ETimeUnit2) => {
  ETimeUnit2[ETimeUnit2["MINUTE"] = 0] = "MINUTE";
  ETimeUnit2[ETimeUnit2["HOUR"] = 1] = "HOUR";
  ETimeUnit2[ETimeUnit2["SESSION"] = 1] = "SESSION";
  return ETimeUnit2;
})(ETimeUnit || {});
var ERelativePosition = /* @__PURE__ */ ((ERelativePosition2) => {
  ERelativePosition2["BEFORE"] = "before";
  ERelativePosition2["AFTER"] = "after";
  ERelativePosition2["IN"] = "in";
  return ERelativePosition2;
})(ERelativePosition || {});




/***/ }),

/***/ 982226:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ Container; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var _BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(640128);
/* harmony import */ var _Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(208984);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(212951);
/* harmony import */ var _helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19840);






var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
const Wrapper = _emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"].div`
  padding-right: 16px;
  padding-left: 16px;
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${_Grid_constant_es_js__WEBPACK_IMPORTED_MODULE_2__/* .BREAK_POINTS.xl */ .d.xl}) {
    width: ${(props) => props.fluid ? "100%" : (0,_helpers_utils_es_js__WEBPACK_IMPORTED_MODULE_3__/* .pixelParse */ .oJ)(props.maxWidth || "")};
  }
  ${_BaseProps_index_es_js__WEBPACK_IMPORTED_MODULE_4__/* .CommonStyles */ .F}
`;
const Container = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef((props, ref) => {
  const _a = props, { children, fluid = false, maxWidth = 1232 } = _a, others = __objRest(_a, ["children", "fluid", "maxWidth"]);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(Wrapper, __spreadValues({
    maxWidth,
    fluid,
    ref
  }, others), children);
});
Container.displayName = "Container";




/***/ }),

/***/ 380822:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ s; }
/* harmony export */ });
class s{constructor(s,e,t){this.message=s,this.response=t,this.code=e}get reason(){return this.response}}


/***/ }),

/***/ 988966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ u; }
/* harmony export */ });
/* harmony import */ var opentracing__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83492);
/* harmony import */ var opentracing__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(opentracing__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _error_es_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(380822);
var s=Object.defineProperty,a=Object.defineProperties,n=Object.getOwnPropertyDescriptors,o=Object.getOwnPropertySymbols,i=Object.prototype.hasOwnProperty,c=Object.prototype.propertyIsEnumerable,p=(t,e,r)=>e in t?s(t,e,{enumerable:!0,configurable:!0,writable:!0,value:r}):t[e]=r,h=(t,e)=>{for(var r in e||(e={}))i.call(e,r)&&p(t,r,e[r]);if(o)for(var r of o(e))c.call(e,r)&&p(t,r,e[r]);return t};const l=(t="",e)=>`${t.endsWith("/")?t.slice(0,t.length-1):t}/${e.startsWith("/")?e.slice(1):e}`;class u{constructor(t,e,r={}){this.baseURL=t,this.interceptors=[],this.getError=e,this.defaultConfig=r}_parseJson(t){return t.text().then((t=>t?JSON.parse(t):null))}addInterceptor(t){this.interceptors.push(t)}appendParamsToURL(t,e={}){if(e){const r=[];for(const t of Object.keys(e))null!==e[t]&&void 0!==e[t]&&r.push(`${t}=${encodeURIComponent(e[t])}`);r.length>0&&(t=`${t}?${r.join("&")}`)}return t}async request(s,o,i,c={}){var p;const{params:u}=c;let f=c.headers||{};const d=this.appendParamsToURL(s,u||{});let g=null;const y=o&&"string"!=typeof o&&"append"in o;o&&"string"!=typeof o&&(y?g=new URLSearchParams(o).toString():(g=JSON.stringify(o),f=h({"Content-Type":"application/json"},f)));let b=null;u&&(b=JSON.stringify(u));const m=(0,opentracing__WEBPACK_IMPORTED_MODULE_0__.globalTracer)(),w=`[${i}] ${l(this.baseURL,s)}`,O=m.startSpan(w);m.inject(O,opentracing__WEBPACK_IMPORTED_MODULE_0__.FORMAT_HTTP_HEADERS,f),O.setTag("http.method",i),O.setTag("http.baseurl",this.baseURL),O.log({body:g,params:b});const j=(P=h({},this.defaultConfig),T={method:i,headers:new Headers(f),body:y?o:g},a(P,n(T)));var P,T;this.interceptors.forEach((t=>t(j)));const E=await fetch(d.startsWith("http")?d:l(this.baseURL,d),j);if(E.status>=400){const t=await E.json(),e=(null==(p=this.getError)?void 0:p.call(this,t))||new _error_es_js__WEBPACK_IMPORTED_MODULE_1__/* .ApiError */ .M("Đã có lỗi xảy ra, vui lòng thử lại sau!",-1,t);return O.setTag("status","error"),O.log({error:JSON.stringify(e)}),O.finish(),Promise.reject(e)}const v={};E.headers.forEach(((t,e)=>v[e]=t));const S=await this._parseJson(E);return O.setTag("status","success"),O.finish(),{code:E.status,data:S,headers:v}}async get(t,e={}){return await this.request(t,null,"GET",e)}async post(t,e,r={}){return await this.request(t,e,"POST",r)}async patch(t,e,r={}){return await this.request(t,e,"PATCH",r)}async put(t,e,r={}){return await this.request(t,e,"PUT",r)}async delete(t,e={},r={}){return await this.request(t,e,"DELETE",r)}}


/***/ }),

/***/ 228976:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/default/desktop/search",
      function () {
        return __webpack_require__(264276);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 665207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ HeadSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(504133);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(979894);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(891987);
/* harmony import */ var _contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(684443);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}





const HeadSection = (param)=>{
    let { title , metaTitle , description , keywords , image , canonical , prevHref , nextHref , noindex =false , links , schemaPage  } = param;
    const { meta  } = (0,_contexts__WEBPACK_IMPORTED_MODULE_3__/* .useTenantConfig */ .Wx)();
    const schemaPageJson = typeof schemaPage === "string" ? (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .getJson */ .LK)(schemaPage) : schemaPage;
    const schemas = Array.isArray(schemaPageJson) ? schemaPageJson : schemaPageJson && [
        schemaPageJson
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "title",
                content: metaTitle || title || meta.title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: metaTitle || title || meta.title
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: description || meta.description
            }),
            keywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: keywords
            }),
            description !== false && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: description || meta.description
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "image",
                content: image || meta.image
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: image || meta.image
            }),
            noindex ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, nofollow"
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "index, follow"
            }),
            canonical && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonical
            }),
            prevHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevHref
            }),
            nextHref && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextHref
            }),
            links === null || links === void 0 ? void 0 : links.map((attrs)=>Object.keys(attrs).length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", _objectSpread({}, attrs))),
            meta.dcmaVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "dmca-site-verification",
                content: meta.dcmaVerificationContent
            }),
            meta.fbDomainVerificationContent && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "facebook-domain-verification",
                content: meta.fbDomainVerificationContent
            }),
            !!(schemas === null || schemas === void 0 ? void 0 : schemas.length) && schemas.map((schema, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(schema)
                    }
                }, index))
        ]
    });
};


/***/ }),

/***/ 124177:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ INLINE_BANNER_CLASSNAME; }
/* harmony export */ });
var INLINE_BANNER_CLASSNAME;
(function(INLINE_BANNER_CLASSNAME) {
    INLINE_BANNER_CLASSNAME["INLINE_HOME_TOP"] = "INLINE-HOME-TOP";
    INLINE_BANNER_CLASSNAME["INLINE_HOME_BODY"] = "INLINE-HOME-BODY";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_RELATEDPROMO"] = "INLINE-PDP-RELATEDPROMO";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_SERVICE"] = "INLINE-PDP-SERVICE";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_PREVIEW_DESK"] = "INLINE-PDP-PREVIEW-DESK";
    INLINE_BANNER_CLASSNAME["INLINE_PDP_PREVIEW_MOBILE"] = "INLINE-PDP-PREVIEW-MOBILE";
    INLINE_BANNER_CLASSNAME["INLINE_SEARCH"] = "INLINE-SEARCH";
    INLINE_BANNER_CLASSNAME["INLINE_CATEGORY"] = "INLINE-CATEGORY";
    INLINE_BANNER_CLASSNAME["INLINE_BRAND"] = "INLINE-BRAND";
    INLINE_BANNER_CLASSNAME["INLINE_SELLER"] = "INLINE-SELLER";
    INLINE_BANNER_CLASSNAME["INLINE_CART"] = "INLINE-CART";
    INLINE_BANNER_CLASSNAME["INLINE_CHECKOUT"] = "INLINE-CHECKOUT";
})(INLINE_BANNER_CLASSNAME || (INLINE_BANNER_CLASSNAME = {}));


/***/ }),

/***/ 264276:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ desktop_search; }
});

// EXTERNAL MODULE: ./modules/search-page/desktop/SearchPage.tsx
var SearchPage = __webpack_require__(550643);
;// CONCATENATED MODULE: ./tenants/_template/desktop/search.tsx

/* harmony default export */ var search = (SearchPage/* SearchPage */.Z);

;// CONCATENATED MODULE: ./pages/default/desktop/search.tsx
// AUTO GENERATED FILE. DO NOT EDIT.

/* harmony default export */ var desktop_search = (search);


/***/ }),

/***/ 167520:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/*!
 * cookie
 * Copyright(c) 2012-2014 Roman Shtylman
 * Copyright(c) 2015 Douglas Christopher Wilson
 * MIT Licensed
 */



/**
 * Module exports.
 * @public
 */

exports.Q = parse;
__webpack_unused_export__ = serialize;

/**
 * Module variables.
 * @private
 */

var __toString = Object.prototype.toString

/**
 * RegExp to match field-content in RFC 7230 sec 3.2
 *
 * field-content = field-vchar [ 1*( SP / HTAB ) field-vchar ]
 * field-vchar   = VCHAR / obs-text
 * obs-text      = %x80-FF
 */

var fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;

/**
 * Parse a cookie header.
 *
 * Parse the given cookie header string into an object
 * The object has the various cookies as keys(names) => values
 *
 * @param {string} str
 * @param {object} [options]
 * @return {object}
 * @public
 */

function parse(str, options) {
  if (typeof str !== 'string') {
    throw new TypeError('argument str must be a string');
  }

  var obj = {}
  var opt = options || {};
  var dec = opt.decode || decode;

  var index = 0
  while (index < str.length) {
    var eqIdx = str.indexOf('=', index)

    // no more cookie pairs
    if (eqIdx === -1) {
      break
    }

    var endIdx = str.indexOf(';', index)

    if (endIdx === -1) {
      endIdx = str.length
    } else if (endIdx < eqIdx) {
      // backtrack on prior semicolon
      index = str.lastIndexOf(';', eqIdx - 1) + 1
      continue
    }

    var key = str.slice(index, eqIdx).trim()

    // only assign once
    if (undefined === obj[key]) {
      var val = str.slice(eqIdx + 1, endIdx).trim()

      // quoted values
      if (val.charCodeAt(0) === 0x22) {
        val = val.slice(1, -1)
      }

      obj[key] = tryDecode(val, dec);
    }

    index = endIdx + 1
  }

  return obj;
}

/**
 * Serialize data into a cookie header.
 *
 * Serialize the a name value pair into a cookie string suitable for
 * http headers. An optional options object specified cookie parameters.
 *
 * serialize('foo', 'bar', { httpOnly: true })
 *   => "foo=bar; httpOnly"
 *
 * @param {string} name
 * @param {string} val
 * @param {object} [options]
 * @return {string}
 * @public
 */

function serialize(name, val, options) {
  var opt = options || {};
  var enc = opt.encode || encode;

  if (typeof enc !== 'function') {
    throw new TypeError('option encode is invalid');
  }

  if (!fieldContentRegExp.test(name)) {
    throw new TypeError('argument name is invalid');
  }

  var value = enc(val);

  if (value && !fieldContentRegExp.test(value)) {
    throw new TypeError('argument val is invalid');
  }

  var str = name + '=' + value;

  if (null != opt.maxAge) {
    var maxAge = opt.maxAge - 0;

    if (isNaN(maxAge) || !isFinite(maxAge)) {
      throw new TypeError('option maxAge is invalid')
    }

    str += '; Max-Age=' + Math.floor(maxAge);
  }

  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }

    str += '; Domain=' + opt.domain;
  }

  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }

    str += '; Path=' + opt.path;
  }

  if (opt.expires) {
    var expires = opt.expires

    if (!isDate(expires) || isNaN(expires.valueOf())) {
      throw new TypeError('option expires is invalid');
    }

    str += '; Expires=' + expires.toUTCString()
  }

  if (opt.httpOnly) {
    str += '; HttpOnly';
  }

  if (opt.secure) {
    str += '; Secure';
  }

  if (opt.partitioned) {
    str += '; Partitioned'
  }

  if (opt.priority) {
    var priority = typeof opt.priority === 'string'
      ? opt.priority.toLowerCase()
      : opt.priority

    switch (priority) {
      case 'low':
        str += '; Priority=Low'
        break
      case 'medium':
        str += '; Priority=Medium'
        break
      case 'high':
        str += '; Priority=High'
        break
      default:
        throw new TypeError('option priority is invalid')
    }
  }

  if (opt.sameSite) {
    var sameSite = typeof opt.sameSite === 'string'
      ? opt.sameSite.toLowerCase() : opt.sameSite;

    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }

  return str;
}

/**
 * URL-decode string value. Optimized to skip native call when no %.
 *
 * @param {string} str
 * @returns {string}
 */

function decode (str) {
  return str.indexOf('%') !== -1
    ? decodeURIComponent(str)
    : str
}

/**
 * URL-encode value.
 *
 * @param {string} val
 * @returns {string}
 */

function encode (val) {
  return encodeURIComponent(val)
}

/**
 * Determine if value is a Date.
 *
 * @param {*} val
 * @private
 */

function isDate (val) {
  return __toString.call(val) === '[object Date]' ||
    val instanceof Date
}

/**
 * Try decoding a string using a decoding function.
 *
 * @param {string} str
 * @param {function} decode
 * @private
 */

function tryDecode(str, decode) {
  try {
    return decode(str);
  } catch (e) {
    return str;
  }
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [19303,60687,37070,97968,50643,93712,49774,92888,40179], function() { return __webpack_exec__(228976); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);